import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
import RoutesConverter from '../converter/RoutesConverter';
import ResponseError from './ResponseError';
import Request from './Request';
import convert from 'xml-js';

export default { getRoutes: getRoutes };

// function getRoutes () {
//   return new Promise(resolve =>
//     resolve({
//       status: 0,
//       data: RoutesConverter.routesWireToInt({
//         result: {
//           routes: {
//             route: [
//               {
//                 _attributes: {
//                   route_id: '1',
//                   ret_route: 'Kona to Oakland',
//                 },
//                 _text: 'Oakland to Kona',
//               },
//               {
//                 _attributes: {
//                   route_id: '2',
//                   ret_route: 'Oakland to Kona',
//                 },
//                 _text: 'Kona to Oakland ',
//               },
//             ],
//           },
//         },
//       }),
//     })
//   );
// }

function getRoutes (reservationId) {
  reservationId = reservationId || 0;
  let currentMillis = new Date().getTime();
  return fetch(
    `${
      Constants.BASE_URL
    }?fuseaction=airres.getRoutes&timestamp=${currentMillis}&reservationid=${reservationId}`,
    Request.getBase()
  )
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(response);
          }
          return {
            status: status,
            data: RoutesConverter.routesWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}



// WEBPACK FOOTER //
// ./src/remoting/RoutesRemoting.js